import Select from './Select'
import { DIFFICULTY_OPTIONS } from './Menu'
import { useGameStore } from '../stores/gameStore'

const DIFFICULTY_LABELS: Record<string, string> = {
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
  advanced: 'Advanced',
}

interface BotBattleMenuProps {
  onStartBattle: () => void
  onBack: () => void
}

export default function BotBattleMenu({ onStartBattle, onBack }: BotBattleMenuProps) {
  const { botBattle, setBotBattle } = useGameStore()

  // The bot that moves first plays Red (player 1); the other plays Blue (player 2).
  const bot1Colour = botBattle.bot1First ? 1 : 2
  const bot2Colour = botBattle.bot1First ? 2 : 1

  return (
    <aside className="landing-sidebar">
      <div className="brand-lockup">
        <div className="menu-mark" aria-hidden="true">弈</div>
        <div>
          <h1>Bot Battle</h1>
          <p>Two engines meet across the board</p>
        </div>
      </div>

      <div className="sidebar-actions" aria-label="Battle options">
        <div className="sidebar-field">
          <span className="field-label">
            <span className={`turn-dot turn-dot-${bot1Colour}`} aria-hidden="true" />
            Bot 1
          </span>
          <Select
            ariaLabel="Bot 1 difficulty"
            value={botBattle.bot1Difficulty}
            options={DIFFICULTY_OPTIONS}
            onChange={(value) => setBotBattle({ bot1Difficulty: value as typeof botBattle.bot1Difficulty })}
          />
        </div>

        <div className="sidebar-field">
          <span className="field-label">
            <span className={`turn-dot turn-dot-${bot2Colour}`} aria-hidden="true" />
            Bot 2
          </span>
          <Select
            ariaLabel="Bot 2 difficulty"
            value={botBattle.bot2Difficulty}
            options={DIFFICULTY_OPTIONS}
            onChange={(value) => setBotBattle({ bot2Difficulty: value as typeof botBattle.bot2Difficulty })}
          />
        </div>

        <div className="sidebar-field">
          <span>Who moves first?</span>
          <Select
            ariaLabel="Who moves first"
            value={botBattle.bot1First ? 'bot1' : 'bot2'}
            options={[
              { value: 'bot1', label: 'Bot 1 (Red)' },
              { value: 'bot2', label: 'Bot 2 (Red)' },
            ]}
            onChange={(value) => setBotBattle({ bot1First: value === 'bot1' })}
          />
        </div>

        <button className="sidebar-primary" type="button" onClick={onStartBattle}>
          Start Battle
        </button>
        <button className="sidebar-option" type="button" onClick={onBack}>
          Back
        </button>
      </div>

      <div className="sidebar-note">
        <span>Matchup</span>
        <strong>
          {DIFFICULTY_LABELS[botBattle.bot1Difficulty]} vs {DIFFICULTY_LABELS[botBattle.bot2Difficulty]}
        </strong>
      </div>
    </aside>
  )
}
